import { SystemResponsive } from './systemResponsive';
import { SystemEvent } from './system';

export enum RenderQuality {
    Low,
    High,
    Adapt
}

export class SystemQuality extends SystemResponsive {
    /**
    * Allow to improve quality depending on the device
    * Plus make a even better rendering when animation stop
    */

    constructor(canvas: HTMLCanvasElement) {
        super(canvas);

        this.on(SystemEvent.Stop, () => {
            if (this.quality === RenderQuality.Adapt) {
                this.engine.setHardwareScalingLevel(0.5);
                this.scene.render();
            }
        });
    }

    scalingRatio: number

    protected checkHardwareScaling(): void {
        let scaling = 1;
        if (this.quality === RenderQuality.High) {
            scaling = 0.5;
        } else if (this.quality === RenderQuality.Low) {
            scaling = 1;
        } else {
            //! Use 60 as getFps function returns Fps on base 60
            const fpsBase = 60;
            const fps = Math.min(this.engine.getFps(), fpsBase);
            const scalingFps = (fpsBase - fps) / fpsBase + 0.5;
            const scalingClamp = Math.min(Math.max(scalingFps, 0.5), 1);
            scaling = Math.round(scalingClamp * 10) / 10;
            // For tests purpose
            // scaling = Math.random() / 2 + 0.5;
            // console.log(fps, scaling);
        }
        if (scaling !== this.scalingRatio) {
            this.engine.setHardwareScalingLevel(scaling);
            this.notify(SystemEvent.Scaling, scaling);
            this.scalingRatio = scaling;
        }
    }

    private quality: RenderQuality = RenderQuality.Adapt;

    public setQuality(quality: RenderQuality): void {
        this.quality = quality;
        // Make sure to have the right pixelRatio or Scaling Level won't be right on mobile
        this.checkHardwareScaling();
    }
}
